<template>
    <v-container fluid class="clientDiseases">
        <v-row>
            <v-col cols="12">
                <v-btn color="info" @click="addNewAlergy"  v-if="$can('do','POKO_Klienci_Choroby_Edycja') && type == 1" style="float:left">Dodaj alergie</v-btn>
                <v-btn color="info" @click="addNewDisease"  v-if="$can('do','POKO_Klienci_Choroby_Edycja') && type == 0" style="float:left">Dodaj chorobe</v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-data-table
                        :items="items"
                        :loading="loading"
                        :hide-default-footer="true"
                        disable-pagination
                        :headers="tableHeaders">
                    <template v-slot:item="props">
                        <tr :class="{'cured-disease': props.item.isCured}">
                            <td>{{getFormattedDate(props.item.recognitionTime)}}</td>
                            <td v-if="type == 0">{{getFormattedDate(props.item.curedTime)}}</td>
                            <td>{{props.item.description}}</td>
                            <td><v-sheet v-html="getHtmlICD(props.item)"></v-sheet></td>
                            <td v-if="type == 0">{{getTypeDescription(props.item.subType)}}</td>
                            <td v-if="!hideedit">
                                <v-icon small class="mr-2" v-if="$can('do','POKO_Klienci_Choroby_Edycja') && !hideedit && type == 1" title="Edytuj alergie" @click="editAlergy(props.item)">fa-edit</v-icon>
                                <v-icon small class="mr-2" @click="deleteAlergy(props.item)" title="Usuń" v-if="$can('do','POKO_Klienci_Choroby_Usuwanie') && !hideedit && type == 1">fa-trash-alt</v-icon>

                                <v-icon small class="mr-2" v-if="$can('do','POKO_Klienci_Choroby_Edycja') && !hideedit && type == 0" title="Edytuj alergie" @click="editDisease(props.item)">fa-edit</v-icon>
                                <v-icon small class="mr-2" @click="deleteAlergy(props.item)" title="Usuń" v-if="$can('do','POKO_Klienci_Choroby_Usuwanie') && !hideedit && type == 0">fa-trash-alt</v-icon>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
        <v-dialog v-model="showAddEditAlergy" width="768">
            <AddEditAlergy v-if="showAddEditAlergy" :clientid="clientid" :edited-object="disease" @close="closingEditor"></AddEditAlergy>
        </v-dialog>
        <v-dialog v-model="showAddEditDisease" width="768">
            <AddEditDisease v-if="showAddEditDisease" :clientid="clientid" :edited-object="disease" @close="closingEditor" :subtypes="disaeseSubTypes"></AddEditDisease>
        </v-dialog>
        <v-dialog v-model="showDeleteDialog" width="768">
            <DeleteDisease v-if="showDeleteDialog" :edited-object="disease" @close="closingDeleteDialog"></DeleteDisease>
        </v-dialog>
    </v-container>
</template>

<script>
    import * as dayjs from "dayjs";
    import {clientService} from "../../services";
    import swal from "sweetalert";
    import AddEditAlergy from "./AddEditAlergy";
    import DeleteDisease from "./DeleteDisease";
    import AddEditDisease from "./AddEditDisease";

    export default {
        name: "ClientDiseasesICD",
        props: ["clientid","type","hideedit"],
        data() {
            return {
                loading: false,
                items: [],
                showAddEditAlergy: false,
                showDeleteDialog: false,
                disease: null,
                disease_description: null,
                showAddEditDisease: false,
                disaeseSubTypes: null
            }
        },
        components: {
            AddEditDisease,
            DeleteDisease,
            AddEditAlergy
        },
        mounted() {
            this.refreshVisits()
        },
        computed: {
          tableHeaders: function() {
              if(this.type == 0) {
                  return [{text: 'Data rozpoznania', sortable: false, align: 'left', value: 'recognitionTime'},
                      {text: 'Data wyleczenia', sortable: false, align: 'left', value: 'curedTime'},
                      {text: 'Opis', sortable: false, align: 'left', value: 'description'},
                      {text: 'ICD10', sortable: false, align: 'left', value: 'icd.opisICD'},
                      {text: 'Typ', sortable: false, align: 'left', value: 'subType'},
                      {text: 'Akcje', sortable: false, align: 'left', value: 'id'}]
              }
              else
              {
                  return [{text: 'Data rozpoznania', sortable: false, align: 'left', value: 'recognitionTime'},
                      {text: 'Opis', sortable: false, align: 'left', value: 'description'},
                      {text: 'ICD10', sortable: false, align: 'left', value: 'icd.opisICD'},
                      {text: 'Akcje', sortable: false, align: 'left', value: 'id'}]
              }
          }
        },
        methods: {
            deleteAlergy(obj)
            {
                if(obj != null && obj.id > 0)
                {
                    this.disease = obj
                    this.showDeleteDialog = true
                }
            },
            getHtmlICD(obj)
            {
                return obj.icd != null ? obj.icd.kod + ' ' + obj.icd.opis_icd : ''
            },
            nl2br(str,is_xhtml) {
                var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br/>' : '<br>';
                return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
            },
            closingDeleteDialog() {
              this.disease = null,
              this.showDeleteDialog = false
              this.refreshVisits()
            },
            closingEditor() {

                this.disease = null
                this.showAddEditAlergy = false;
                this.showAddEditDisease = false;
                this.refreshVisits()
            },
            addNewAlergy() {
                this.disease = null
                this.showAddEditAlergy = true
            },
            editAlergy(obj) {
                if(obj && obj.id > 0)
                {
                    this.disease = obj
                    this.showAddEditAlergy = true
                }
            },
            editDisease(obj)
            {
                if(obj && obj.id > 0)
                {
                    this.disease = obj
                    this.showAddEditDisease = true
                }
            },
            addNewDisease() {
               this.disease = null
               this.showAddEditDisease = true
            },
            getTypeDescription(type)
            {
                if(this.disaeseSubTypes != null) {
                    let t = this.disaeseSubTypes.find(x=>x.id == type)
                    if(t != null)
                        return t.description
                }
                return type
            },
            getDisaeseSubTypes()
            {
                clientService.getDisaeseSubTypes().then((results)=> {
                    if(results.data && results.data.result)
                    {
                        this.disaeseSubTypes = results.data.result
                        this.refreshVisits()
                    }
                }).catch(() => {
                    this.showError(false,"Błąd pobierania typów chorzób i schorzeń.")
                })
            },
            refreshVisits() {

                if(this.type == 0 && this.disaeseSubTypes == null)
                {
                    this.getDisaeseSubTypes()
                    return
                }
                clientService.getClientDiseases({ clientId: this.clientid,type: this.type, showAll: true }).then((results)=> {
                    if(results.data && results.data.result)
                    {
                        this.items = results.data.result
                    }
                }).catch(() => {
                    this.showError(false,"Błąd pobierania danych chorób");
                })


            },
            getFormattedDate(val)
            {
                if(!val)
                    return ''
                let dj = dayjs(val)
                if(dj != null)
                {
                    return dj.format("DD-MM-YYYY")
                }
                else
                {
                    return val
                }
            },
            showError(close, text) {
                swal({
                    title: "Błąd",
                    text: text,
                    icon: "warning",
                    button: "OK"
                }).then(() => {
                    this.loading = false;
                    if (close) {
                        this.$emit("close");
                    }
                });
            },
        }
    }
</script>

<style>

</style>
